export const supportAddress = 'support@meetsummer.com';
export const marketingAddress = 'hello@meetsummer.com';
